import script from "./sw-item-parts-text.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-text.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-text.vue?vue&type=style&index=0&id=85e0e31a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e0e31a"]])

export default __exports__